'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** Overlay with dark transparent background, useful for rendering Dialogs in */
var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      style = _ref.style,
      custom = _objectWithoutProperties(_ref, ['children', 'style']);

  return _react2.default.createElement(
    'section',
    _extends({ style: _getStyles2.default.root(style) }, custom),
    children
  );
};

Overlay.propTypes = {
  /** The Overlays children */
  children: _propTypes2.default.node,
  /** Override the style of the root element */
  style: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

Overlay.displayName = 'Overlay';

Overlay.defaultProps = {
  children: null,
  style: {}
};

exports.default = Overlay;
module.exports = exports.default;